import React, { useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Select from '../common/js/react-select'; //TODO: deprecated, replace once react-select removed
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import TimezoneSelect from 'react-timezone-select';
import Tooltip from '@material-ui/core/Tooltip';
import DOMPurify from 'dompurify';
import '../../components/common/css/react-select.css'; //TODO: deprecated, delete once react-select removed
import { DAYS_OPTIONS, ES_LOGS_GROUP_BY_UI_OPTIONS, FREQUENCY_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { bigNumberToText, isEmailValid } from '../utils';

import deleteIcon from '../common/Images/delete.png';
import { Icon, Icons } from '@silverfort/sf-components';

import styles from './CustomReportsModal.module.css';
import { toFirstLetterUppercase } from '@silverfort-nodelibs/common/utils/common';

const CUSTOM_REPORT_DEFAULT_NAME = 'new report';

const GROUP_BY_NO_VALUE = 'None';

const CustomReportsModal = ({
    customReports,
    customFilters,
    onCancel,
    onApprove,
    onDelete,
    authLogsAggsMaxDocsToSearch
}) => {
    const initialState = {
        customReportName: '',
        selectedFilterNames: [],
        selectedFrequency: FREQUENCY_OPTIONS.WEEKLY.value,
        selectedHour: moment().hour(0),
        selectedDayInWeek: DAYS_OPTIONS.MONDAY.value,
        selectedDayInMonth: 1,
        selectedTimezone: {},
        selectedRecipients: [],
        showDeleteOptions: false,
        customReportNameErrorMsg: '',
        selectedFrequencyErrorMsg: '',
        selectedDayInWeekErrorMsg: '',
        selectedDayInMonthErrorMsg: '',
        selectedTimezoneErrorMsg: '',
        selectedFilterNamesErrorMsg: '',
        selectedRecipientsErrorMsg: '',
        setSelectedGroupBy: ''
    };

    const [customReportName, setCustomReportName] = useState(initialState.customReportName);
    const [selectedFilterNames, setSelectedFilterNames] = useState(initialState.selectedFilterNames);
    const [selectedFrequency, setSelectedFrequency] = useState(initialState.selectedFrequency);
    const [selectedHour, setSelectedHour] = useState(initialState.selectedHour);
    const [selectedDayInWeek, setSelectedDayInWeek] = useState(initialState.selectedDayInWeek);
    const [selectedDayInMonth, setSelectedDayInMonth] = useState(initialState.selectedDayInMonth);
    const [selectedTimezone, setSelectedTimezone] = useState(initialState.selectedTimezone);
    const [selectedRecipients, setSelectedRecipients] = useState(initialState.selectedRecipients);

    const [showDeleteOptions, setShowDeleteOptions] = useState(initialState.showDeleteOptions);

    const [customReportNameErrorMsg, setCustomReportNameErrorMsg] = useState(initialState.customReportNameErrorMsg);
    const [selectedFrequencyErrorMsg, setSelectedFrequencyErrorMsg] = useState(initialState.selectedFrequencyErrorMsg);
    const [selectedDayInWeekErrorMsg, setSelectedDayInWeekErrorMsg] = useState(initialState.selectedDayInWeekErrorMsg);
    const [selectedDayInMonthErrorMsg, setSelectedDayInMonthErrorMsg] = useState(
        initialState.selectedDayInMonthErrorMsg
    );
    const [selectedTimezoneErrorMsg, setSelectedTimezoneErrorMsg] = useState(initialState.selectedTimezoneErrorMsg);
    const [selectedFilterNamesErrorMsg, setSelectedFilterNamesErrorMsg] = useState(
        initialState.selectedFilterNamesErrorMsg
    );
    const [selectedRecipientsErrorMsg, setSelectedRecipientsErrorMsg] = useState(
        initialState.selectedRecipientsErrorMsg
    );
    const [selectedGroupBy, setSelectedGroupBy] = useState(initialState.setSelectedGroupBy);

    const clearForm = () => {
        let newReportName = CUSTOM_REPORT_DEFAULT_NAME;
        let increasedIndex = 0;
        let isFound = false;
        const customReportsNames = Object.keys(customReports);
        while (!isFound) {
            newReportName = increasedIndex
                ? `${CUSTOM_REPORT_DEFAULT_NAME} ${increasedIndex}`
                : CUSTOM_REPORT_DEFAULT_NAME;
            if (!customReportsNames.includes(newReportName)) {
                isFound = true;
            }
            increasedIndex++;
        }

        setCustomReportName({ label: newReportName, value: newReportName });

        setSelectedFilterNames(initialState.selectedFilterNames);
        setSelectedFrequency(initialState.selectedFrequency);
        setSelectedHour(initialState.selectedHour);
        setSelectedDayInWeek(initialState.selectedDayInWeek);
        setSelectedDayInMonth(initialState.selectedDayInMonth);
        setSelectedTimezone(initialState.selectedTimezone);
        setSelectedRecipients(initialState.selectedRecipients);
        setShowDeleteOptions(initialState.showDeleteOptions);
        setCustomReportNameErrorMsg(initialState.customReportNameErrorMsg);
        setSelectedFrequencyErrorMsg(initialState.selectedFrequencyErrorMsg);
        setSelectedDayInWeekErrorMsg(initialState.selectedDayInWeekErrorMsg);
        setSelectedDayInMonthErrorMsg(initialState.selectedDayInMonthErrorMsg);
        setSelectedTimezoneErrorMsg(initialState.selectedTimezoneErrorMsg);
        setSelectedFilterNamesErrorMsg(initialState.selectedFilterNamesErrorMsg);
        setSelectedRecipientsErrorMsg(initialState.selectedRecipientsErrorMsg);
    };

    const groupByOptions = Object.values(ES_LOGS_GROUP_BY_UI_OPTIONS).map(({ label, value }) => ({
        label: toFirstLetterUppercase(label),
        value
    }));

    const sanitizeInput = (input) => {
        return DOMPurify.sanitize(input, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
    };

    const onCustomReportNameChange = (newVal) => {
        if (!newVal) {
            setCustomReportNameErrorMsg('*Report name cannot be empty');
            setCustomReportName('');
            return;
        }
        setCustomReportNameErrorMsg('');
        setShowDeleteOptions(false);
        setCustomReportName(newVal);
        if (Object.keys(customReports).includes(newVal.value)) {
            setSelectedFilterNames(
                customReports[newVal.value].customFilters.map((customFilter) => {
                    return { label: customFilter, value: customFilter };
                })
            );
            setSelectedFrequency(customReports[newVal.value].frequency);
            setSelectedHour(moment().set('hour', customReports[newVal.value].hour));
            setSelectedDayInWeek(customReports[newVal.value].dayInWeek);
            setSelectedDayInMonth(customReports[newVal.value].dayInMonth);
            setSelectedTimezone(customReports[newVal.value].timezone);
            setSelectedRecipients(
                customReports[newVal.value].recipients.map((recipient) => {
                    return { label: recipient, value: recipient };
                })
            );
            setSelectedGroupBy(customReports[newVal.value].groupBy);
        }
    };

    const onCustomReportFrequencyChange = (newVal) => {
        setSelectedFrequencyErrorMsg(!newVal ? '*Report Frequency cannot be empty' : '');
        setSelectedFrequency(!newVal ? '' : newVal);

        if (newVal === FREQUENCY_OPTIONS.WEEKLY.value) {
            setSelectedDayInMonthErrorMsg('');
        } else if (newVal === FREQUENCY_OPTIONS.MONTHLY.value) {
            setSelectedDayInWeekErrorMsg('');
        } else {
            setSelectedDayInMonthErrorMsg('');
            setSelectedDayInWeekErrorMsg('');
        }
    };

    const onCustomReportDayInWeekChange = (newVal) => {
        const isValid = newVal && selectedFrequency === FREQUENCY_OPTIONS.WEEKLY.value;
        setSelectedDayInWeekErrorMsg(!isValid ? '*Report Day cannot be empty' : '');
        setSelectedDayInWeek(!isValid ? '' : newVal);
    };

    const onCustomReportDayInMonthChange = (newVal) => {
        const isValid = newVal && selectedFrequency === FREQUENCY_OPTIONS.MONTHLY.value;
        setSelectedDayInMonthErrorMsg(!isValid ? '*Report Day cannot be empty' : '');
        setSelectedDayInMonth(!isValid ? '' : newVal);
    };

    const onCustomReportTimezoneChange = (newVal) => {
        setSelectedTimezoneErrorMsg(!newVal ? '*Report Timezone cannot be empty' : '');
        setSelectedTimezone(!newVal ? '' : newVal);
    };

    const onCustomReportFilterChange = (newVal) => {
        setSelectedFilterNamesErrorMsg(newVal.length === 0 ? `*Report 'Custom filters' cannot be empty` : '');
        setSelectedFilterNames(newVal);
    };

    const onCustomReportGroupByChange = (newVal) => {
        setSelectedGroupBy(newVal?.value);
    };

    const onCustomReportRecipientsChange = (newVal) => {
        if (newVal.length === 0) {
            setSelectedRecipientsErrorMsg(`*Report Recipients cannot be empty`);
        } else {
            const badEmails = [];
            for (const emailObj of newVal) {
                if (!isEmailValid(emailObj.value)) {
                    badEmails.push(emailObj.value);
                }
            }
            if (badEmails.length > 0) {
                setSelectedRecipientsErrorMsg(
                    `*Recipient${badEmails.length > 1 ? 's' : ''} ${badEmails.join(', ')} ${
                        badEmails.length > 1 ? 'are' : 'is'
                    } not a valid email${badEmails.length > 1 ? 's' : ''}`
                );
            } else {
                setSelectedRecipientsErrorMsg(``);
            }
        }
        setSelectedRecipients(newVal);
    };
    const validateReport = () => {
        let isValid = !selectedFrequencyErrorMsg && !selectedRecipientsErrorMsg;
        if (!customReportName || !customReportName.value) {
            isValid = false;
            setCustomReportNameErrorMsg('*Report name cannot be empty');
        }

        if (selectedFrequency === FREQUENCY_OPTIONS.WEEKLY.value && !selectedDayInWeek) {
            isValid = false;
            setSelectedDayInWeekErrorMsg('*Report day cannot be empty');
        } else if (selectedFrequency === FREQUENCY_OPTIONS.MONTHLY.value && !selectedDayInMonth) {
            isValid = false;
            setSelectedDayInMonthErrorMsg('*Report day cannot be empty');
        }

        if (Object.keys(selectedTimezone).length === 0) {
            isValid = false;
            setSelectedTimezoneErrorMsg('*Report Timezone cannot be empty');
        }

        if (selectedFilterNames.length === 0) {
            isValid = false;
            setSelectedFilterNamesErrorMsg(`*Report 'Custom filter' cannot be empty`);
        }

        if (selectedRecipients.length === 0) {
            setSelectedRecipientsErrorMsg(`*Report Recipients cannot be empty`);
        }
        return isValid;
    };

    const onSaveClicked = () => {
        const stringReportName =
            typeof customReportName === 'object'
                ? sanitizeInput(customReportName.value)
                : sanitizeInput(customReportName);
        if (showDeleteOptions) {
            onDelete(stringReportName);
            return;
        }

        const customReportObj = {
            reportName: stringReportName,
            customFilters: selectedFilterNames.map((filter) => filter.value),
            frequency: selectedFrequency,
            hour: selectedHour.hour(),
            timezone: selectedTimezone,
            dayInWeek: selectedDayInWeek,
            dayInMonth: selectedDayInMonth,
            recipients: selectedRecipients.map((recipients) => recipients.value),
            groupBy: selectedGroupBy
        };

        if (validateReport()) {
            onApprove(customReportObj);
        }
    };

    const onCancelClicked = () => {
        if (showDeleteOptions) {
            setShowDeleteOptions(false);
            return;
        }
        onCancel();
    };

    const getReportNamesOptions = (inputValue) => {
        return Promise.resolve({
            options: Object.keys(customReports)
                .filter((reportName) => {
                    return !inputValue || reportName.toLowerCase().includes(inputValue.toLowerCase());
                })
                .map((reportName) => {
                    return { label: reportName, value: reportName };
                })
        });
    };

    const getRecipientsOptions = () => {
        const recipients = [];
        for (const reportName of Object.keys(customReports)) {
            for (const recipient of customReports[reportName].recipients) {
                if (!recipients.includes(recipient)) {
                    recipients.push(recipient);
                }
            }
        }
        const options = recipients.map((recipient) => {
            return { label: recipient, value: recipient };
        });

        return Promise.resolve({
            options: options
        });
    };

    const stringReportName = typeof customReportName === 'object' ? customReportName.value : customReportName;
    return (
        <Modal id={styles.customReportsModal} show={true} keyboard={true} backdrop="static" className="z-[5000]">
            <Modal.Header>
                <Modal.Title>
                    Custom reports
                    <div className={styles.createEmpty}>
                        <Button bsStyle="info" onClick={clearForm}>
                            Create empty report
                        </Button>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass="modal-body overflow-auto">
                <div>
                    <div className={styles.reportNameContainer}>
                        <span className={styles.fieldLabel}>Report name:</span>
                        {/* TODO: deprecated, replace once react-select removed */}
                        <Select.AsyncCreatable
                            placeholder={'Search for a report or enter a new report name'}
                            className={`${styles.reportGeneralFieldInput} ${styles.selectInputField}`}
                            name="form-field-name"
                            value={customReportName}
                            onChange={onCustomReportNameChange}
                            clearable={false}
                            searchable={true}
                            backspaceRemoves={false}
                            loadOptions={getReportNamesOptions}
                            promptTextCreator={(name) => `Create new report name “${name}”`}
                        />
                    </div>
                    <div className={styles.validationErrorMsg}>{customReportNameErrorMsg}</div>
                </div>
                <div className={styles.reportTimeSelectionContainer}>
                    <div>
                        <div className={styles.frequencySelectionDiv}>
                            <span className={styles.fieldLabel}>Frequency:</span>
                            <div className={styles.reportTimeSelectItem}>
                                <Select
                                    className={styles.reportTimeSelect}
                                    name="form-field-name"
                                    value={selectedFrequency}
                                    onChange={onCustomReportFrequencyChange}
                                    clearable={false}
                                    searchable={true}
                                    backspaceRemoves={false}
                                    simpleValue
                                    options={Object.values(FREQUENCY_OPTIONS)}
                                />
                            </div>
                        </div>
                        {selectedFrequencyErrorMsg && (
                            <div className={styles.validationErrorMsg}>{selectedFrequencyErrorMsg}</div>
                        )}
                    </div>

                    {selectedFrequency === FREQUENCY_OPTIONS.WEEKLY.value && (
                        <div>
                            <div className={styles.daySelectionDiv}>
                                <span className={styles.fieldLabel}>Day:</span>
                                <div className={styles.reportTimeSelectItem}>
                                    <Select
                                        className={styles.reportTimeSelect}
                                        name="form-field-name"
                                        value={selectedDayInWeek}
                                        onChange={onCustomReportDayInWeekChange}
                                        clearable={false}
                                        searchable={true}
                                        backspaceRemoves={false}
                                        simpleValue
                                        options={Object.values(DAYS_OPTIONS)}
                                    />
                                </div>
                            </div>
                            {selectedDayInWeekErrorMsg && (
                                <div className={styles.validationErrorMsg}>{selectedDayInWeekErrorMsg}</div>
                            )}
                        </div>
                    )}
                    {selectedFrequency === FREQUENCY_OPTIONS.MONTHLY.value && (
                        <div>
                            <div className={styles.dayDateSelectionDiv}>
                                <span className={styles.fieldLabel}>Day:</span>
                                <div className={styles.reportTimeSelectItem}>
                                    <Select
                                        className={styles.reportTimeSelect}
                                        name="form-field-name"
                                        value={selectedDayInMonth}
                                        onChange={onCustomReportDayInMonthChange}
                                        clearable={false}
                                        searchable={true}
                                        backspaceRemoves={false}
                                        simpleValue
                                        options={[...Array(31).keys()].map((day) => {
                                            return { label: day + 1, value: day + 1 };
                                        })}
                                    />
                                </div>
                            </div>
                            {selectedDayInMonthErrorMsg && (
                                <div className={styles.validationErrorMsg}>{selectedDayInMonthErrorMsg}</div>
                            )}
                        </div>
                    )}
                    <div>
                        <div className={styles.timeSelectionContainer}>
                            <div className={styles.timeSelectionDiv}>
                                <span className={styles.fieldLabel}>Time:</span>

                                <div className={styles.reportTimeSelectItem}>
                                    <TimePicker
                                        showSecond={false}
                                        showMinute={false}
                                        value={selectedHour}
                                        onChange={(value) => {
                                            setSelectedHour(value);
                                        }}
                                        use12Hours
                                    />
                                </div>
                            </div>

                            <div className={styles.timezoneSelectionDiv}>
                                <span className={styles.fieldLabel}>Timezone:</span>
                                <TimezoneSelect
                                    className={styles.reportGeneralFieldInput}
                                    value={selectedTimezone}
                                    onChange={onCustomReportTimezoneChange}
                                />
                            </div>
                        </div>
                        <div className={styles.validationErrorMsg}>{selectedTimezoneErrorMsg}</div>
                    </div>
                </div>

                <div>
                    <div className={styles.reportGeneralField}>
                        <div className={styles.fieldLabel}>
                            Custom filters:
                            <Tooltip
                                title={
                                    'Select custom filters for the report. Only filters with a date range can be used.'
                                }
                                arrow={true}
                                classes={{ tooltip: 'generic-tooltip' }}
                                placement="right">
                                <div className="moreInfoIcon" />
                            </Tooltip>
                        </div>

                        <Select
                            className={`${styles.reportGeneralFieldInput} ${styles.selectInputField}`}
                            name="form-field-name"
                            value={selectedFilterNames}
                            onChange={onCustomReportFilterChange}
                            clearable={false}
                            backspaceRemoves={false}
                            options={Object.keys(customFilters)
                                .filter((customFilter) => {
                                    return customFilters[customFilter].selectedFilters.range;
                                })
                                .map((customFilter) => {
                                    return { label: customFilter, value: customFilter };
                                })}
                            multi
                        />
                    </div>
                    <div className={styles.validationErrorMsg}>{selectedFilterNamesErrorMsg}</div>
                </div>

                <div>
                    <div className={styles.reportGeneralField}>
                        <div className={styles.fieldLabel}>
                            Group by:
                            <Tooltip
                                title={`The group by function will work when the number of log entries is less than ${bigNumberToText(
                                    authLogsAggsMaxDocsToSearch
                                )}`}
                                arrow={true}
                                classes={{ tooltip: 'generic-tooltip' }}
                                placement="right">
                                <div className="moreInfoIcon" />
                            </Tooltip>
                        </div>

                        <Select
                            className={`${styles.reportGeneralFieldInput} ${styles.selectInputField}`}
                            name="form-field-name"
                            value={selectedGroupBy}
                            onChange={onCustomReportGroupByChange}
                            clearable={true}
                            options={groupByOptions}
                            placeholder={GROUP_BY_NO_VALUE}
                        />
                    </div>
                </div>

                <div>
                    <div className={styles.reportGeneralField}>
                        <span className={styles.fieldLabel}>Recipients:</span>
                        <Select.AsyncCreatable
                            placeholder={'Select recipients or enter email address'}
                            className={`${styles.reportGeneralFieldInput} ${styles.selectInputField}`}
                            name="form-field-name"
                            value={selectedRecipients}
                            onChange={onCustomReportRecipientsChange}
                            clearable={false}
                            searchable={true}
                            backspaceRemoves={false}
                            loadOptions={getRecipientsOptions}
                            multi={true}
                            promptTextCreator={(name) => `Create new email recipient “${name}”`}
                        />
                    </div>
                    <div className={styles.validationErrorMsg}>{selectedRecipientsErrorMsg}</div>
                </div>
                <div className="flex items-center mb-2">
                    <Icon icon={Icons.CircleInfo} className="mr-2 text-sf-neutral-500 w-5 h-5" />
                    <span className="text-xs font-normal text-[#686A6C] leading-[18px]">
                        File may be reduced due to size limitations
                    </span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className={styles.modalFooter}>
                    <div className={styles.footerLeftSide}>
                        {Object.keys(customReports).includes(stringReportName) && (
                            <img
                                className={`${styles.deleteReportImg}`}
                                src={deleteIcon}
                                onClick={() => {
                                    setShowDeleteOptions(!showDeleteOptions);
                                }}
                                alt=""
                            />
                        )}
                        {showDeleteOptions && (
                            <span className={styles.deletionWarning}>
                                {`Are you sure you want to delete '${stringReportName}'?`}
                            </span>
                        )}
                    </div>
                    <div className={styles.footerRightSide}>
                        <Button onClick={onCancelClicked}>Cancel</Button>
                        <Button bsStyle={showDeleteOptions ? 'danger' : 'success'} onClick={onSaveClicked}>
                            {showDeleteOptions
                                ? 'Delete'
                                : Object.keys(customReports).includes(stringReportName)
                                ? 'Update'
                                : 'Create'}
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomReportsModal;
